<script setup lang="ts">
import { watch } from 'vue';
import { useRoute } from 'vue-router';

import AppSidebar from '@components/organisms/AppSidebar.vue';
import AppTopBar from '@components/organisms/AppTopBar.vue';
import { provideSidebar } from '@composables/useSidebar';

const { contentMargin, isPinned, close } = provideSidebar();
const route = useRoute();

watch(
  () => route.path,
  () => {
    if (!isPinned.value) {
      close();
    }
  },
);
</script>

<template>
  <div class="bg-muted min-h-screen">
    <AppSidebar />

    <div
      class="flex h-screen flex-col transition-[margin-left] duration-200 ease-in-out"
      :style="{ marginLeft: contentMargin }"
    >
      <AppTopBar />

      <main class="min-h-0 flex-1 overflow-auto p-4 sm:p-6">
        <slot />
      </main>
    </div>
  </div>
</template>
